import React from 'react';
import { Badge, Grid, Tabs } from 'framework-ui-components';
import StatoDichiarazione from 'enums/StatoDichiarazione';
import { StatiRicerca } from 'enums';

const badgeConteggio = (contatoreStato = {}) => (contatoreStato.Totale > 0 ? <Badge info>{contatoreStato.Totale}</Badge> : null);

const decodificaStato = (idx) => {
  switch (idx) {
    case 1:
      return StatoDichiarazione.InLavorazione;
    case 2:
      return StatoDichiarazione.Completa;
    case 3:
      return StatoDichiarazione.TrasmessaEPASA;
    case 4:
      return StatoDichiarazione.ScartataEPASA;
    default:
      return idx;
  }
};

export default ({ avviaRicerca, contatoriStati }) => (
  <Grid fluid className="pl-0 pr-0">
    <Grid.Row>
      <Grid.Col md="12">
        <Tabs onSelect={idx => avviaRicerca({ stato: decodificaStato(idx) })}>
          <Tabs.Tab
            title={(
              <span>
                Tutte {badgeConteggio(contatoriStati.find(x => x.Stato == StatiRicerca.TUTTE))}
              </span>
            )}
          />
          <Tabs.Tab
            title={(
              <span>
                In lavorazione{' '}
                {badgeConteggio(
                  contatoriStati.find(x => x.Stato == StatiRicerca.IN_LAVORAZIONE),
                )}
              </span>
            )}
          />
          <Tabs.Tab
            title={(
              <span>
                Complete{' '}
                {badgeConteggio(contatoriStati.find(x => x.Stato == StatiRicerca.COMPLETE))}
              </span>
            )}
          />
          <Tabs.Tab
            title={(
              <span>
                Trasmesse{' '}
                {badgeConteggio(
                  contatoriStati.find(x => x.Stato == StatiRicerca.TRASMESSE_EPASA),
                )}
              </span>
            )}
          />
          <Tabs.Tab
            title={(
              <span>
                Scartate{' '}
                {badgeConteggio(
                  contatoriStati.find(x => x.Stato == StatiRicerca.SCARTATA_EPASA),
                )}
              </span>
            )}
          />
        </Tabs>
      </Grid.Col>
    </Grid.Row>
  </Grid>
);
